// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.hub-panel[data-v-60433d38] {\n  position: relative;\n  overflow: hidden;\n}\n.hub-panel-logo[data-v-60433d38] {\n  background: white;\n}\n\n/*Bug hack https://github.com/vuetifyjs/vuetify/issues/9175 */\n.v-dialog__container[data-v-60433d38] {\n  display: unset;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
